// Lightweight dependency-free SVG line chart (multi-series)
export default function LineChart({ series = [], lines = [], height = 150 }) {
  const W = 320, H = height, padL = 6, padR = 6, padT = 12, padB = 16;
  const n = series.length;
  if (!n) return <div className="flex h-[150px] items-center justify-center text-xs text-muted-foreground">No data</div>;
  const maxV = Math.max(1, ...lines.flatMap((l) => series.map((s) => s[l.key] || 0)));
  const x = (i) => padL + (i / Math.max(1, n - 1)) * (W - padL - padR);
  const y = (v) => padT + (1 - v / maxV) * (H - padT - padB);
  const path = (key) => series.map((s, i) => `${i === 0 ? 'M' : 'L'}${x(i).toFixed(1)},${y(s[key] || 0).toFixed(1)}`).join(' ');
  const area = (key) => `${path(key)} L${x(n - 1).toFixed(1)},${(H - padB).toFixed(1)} L${x(0).toFixed(1)},${(H - padB).toFixed(1)} Z`;
  return (
    <div>
      <svg viewBox={`0 0 ${W} ${H}`} className="w-full" preserveAspectRatio="none" style={{ height }}>
        {[0.25, 0.5, 0.75].map((g) => (
          <line key={g} x1={padL} x2={W - padR} y1={padT + g * (H - padT - padB)} y2={padT + g * (H - padT - padB)} stroke="hsl(var(--border))" strokeWidth="0.5" strokeDasharray="2 3" />
        ))}
        {lines.map((l) => (
          <g key={l.key}>
            <defs>
              <linearGradient id={`grad-${l.key}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={l.color} stopOpacity="0.35" />
                <stop offset="100%" stopColor={l.color} stopOpacity="0" />
              </linearGradient>
            </defs>
            <path d={area(l.key)} fill={`url(#grad-${l.key})`} />
            <path d={path(l.key)} fill="none" stroke={l.color} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
          </g>
        ))}
      </svg>
      <div className="mt-1 flex items-center justify-between text-[10px] text-muted-foreground">
        <span>{(series[0].date || '').slice(5)}</span>
        <div className="flex gap-3">
          {lines.map((l) => (
            <span key={l.key} className="flex items-center gap-1"><span className="h-2 w-2 rounded-full" style={{ background: l.color }} />{l.label}</span>
          ))}
        </div>
        <span>{(series[n - 1].date || '').slice(5)}</span>
      </div>
    </div>
  );
}
